<template>
  <div>
    <main style='background: #EEEEEE;height: 900px;'>
      <img src="../../assets/images/banner_bg.jpg" alt="" class="topImg">
      <div class="centerBox">
        <div class="liucheng">
          <div class="flex">
            <ul>
              <li @click="select(item, index)" v-for="(item, index) in list" :key="index" :class="{ active: activeNum === index }">
                {{ item.name }}
              </li>
            </ul>
            <div>
              <img src="../../../images/index_banner.png" alt="" class="contentImg"/>
              <div class="content">{{ aboutxhContent() }}</div>
            </div>
          </div>
        </div>
      </div>
    </main>
  </div>
</template>

<script>
import {aboutxhContent} from "@/utils/mack";

export default {
  name: 'about',
  data() {
    return {
      activeNum: 0,
      list: [
        {name: '关于协会'},
      ],
    };
  },
  methods: {
    select(item, index) {
      this.activeNum = index
    },
    aboutxhContent() {
      return aboutxhContent;
    }
  },
};
</script>

<style lang="less" scoped>
.topImg {
  width: 100%;
  display: block;
}

.centerBox {
  width: 1134px;
  margin: 0 auto;
  overflow: hidden;
  box-sizing: border-box;
}

.titleTip {
  width: 100%;
  border-left: 4px solid #01458E;
  padding-left: 10px;
}

.liucheng {
  position: absolute;
  top: 300px;

  & > div {
    width: 1134px;
    height: 700px;
    margin: 0 auto;
    padding: 30px;
    box-sizing: border-box;
    background: #fff;
    overflow: hidden;

    & > ul {

      & > li {
        width: 150px;
        line-height: 50px;
        text-align: center;
        cursor: pointer;
        position: relative;

        &::after {
          position: absolute;
          right: -16px;
          top: 16px;
          display: inline-block;
          content: '';
          border: 8px solid transparent;
        }

        &.active {
          background: #076CE0;
          color: #fff;

          &::after {
            border-left-color: #076CE0;
          }
        }
      }
    }

    & > div {
      padding: 0 20px 20px;
      box-sizing: border-box;
      overflow: hidden;

    }
  }

  .contentImg {
    width: 100%;
    height: 200px;
    margin-bottom: 20px;
  }

  .content {
    font-family: PingFangRegular;
    font-size: 16px;
    color: #000000;
    line-height: 32px;
    text-indent: 30px;
  }

}
</style>
